module.exports = __webpack_public_path__ + "img/page-empty-list-light.e149cca3.svg";